import * as React from 'react';
import { ErrorBoundary } from '../errors/ErrorBoundary';
import { ActionSelection } from './DeviceInteractionModal/ActionSelection';
import { Upload } from './DeviceInteractionModal/Upload';
import { Success } from './DeviceInteractionModal/Success';
import { Failure } from './DeviceInteractionModal/Failure';
import { SessionSelection } from './DeviceInteractionModal/SessionSelection';
import { MailConfirmation } from './DeviceInteractionModal/Mail/MailConfirmation';
import { CloseInteractionModalAction, DevicesAction } from './DevicesNewReducer';
import { useDevicesStateContext } from './DevicesStateContext';
import { DeviceUnresponsive } from './DeviceInteractionModal/DeviceUnresponsiveInstruction';

export interface OmniInteractionModalProps {
    dispatch: React.Dispatch<DevicesAction>;
}

export const OmniInteractionModal = ({ dispatch }: OmniInteractionModalProps) => {
    const { upload: {deviceStatus, selectedSessionIds }, mail: { isFetchingAddress, mailAddress }, interactionModalStep, isOmniInteractionModalVisible, selectedAction, deviceInteractions, activeSelectedDevice, selectedDevices, currentStatusText } = useDevicesStateContext();


    const handleClose = () => {
        dispatch(CloseInteractionModalAction.create());
    }

    const renderPage = (page) => {
        switch (page) {
            case 1:
                return (<ActionSelection dispatch={dispatch} selectedOption={selectedAction} options={deviceInteractions} />);
            case 2:
                return (<SessionSelection dispatch={dispatch} />);
            case 3:
                return (<Upload
                    deviceType={activeSelectedDevice ? activeSelectedDevice.type : selectedDevices[0].type}
                    dispatch={dispatch}
                />);
            case 4:
                return (<Success explanationText={currentStatusText} selectedInteraction={selectedAction} devices={selectedDevices} deviceStatuses={deviceStatus} handleNext={() => handleClose()} />);
            case 5:
                return (<Failure explanationText={currentStatusText} handleClose={handleClose} devices={selectedDevices} deviceStatuses={deviceStatus} />);
            case 10:
                return (<MailConfirmation
                    isFetchingAddress={isFetchingAddress}
                    mailAddress={mailAddress}
                    selectedSessionIds={selectedSessionIds}
                    dispatch={dispatch}
                />);
            case 11:
                return (<DeviceUnresponsive onClose={handleClose}/>);
        }
        return (null);
    }

    if (!isOmniInteractionModalVisible) {
        return null;
    } else {
        return (
            <div>
                <div className="modal-backdrop fade in"></div>
                <div id="device-return-wizard" className="modal show">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <ErrorBoundary>
                                {renderPage(interactionModalStep)}
                            </ErrorBoundary>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
